// extracted by mini-css-extract-plugin
export default {"unreadMessages":"ClientRow_unreadMessages__wZx9D","descriptor":"ClientRow_descriptor__fqo9f"};